module.exports = new __parcel__URL__("72107_h.f2ee0f2f.jpg").toString();